// extracted by mini-css-extract-plugin
module.exports = {"modal":"InfoModal_modal__1mLV0","container":"InfoModal_container__2hbK6","btnWrapper":"InfoModal_btnWrapper__CwH2s"};